import * as THREE from 'three';
import { ThreeView } from '..';
import { CanvasInfo, defines } from '../../base';
import * as marietta from '../../..';
import {
  PINPICTURE3D_MAXHEIGHT,
  PINPICTURE3D_MAXWIDTH,
} from '../../../webcad/Constants';

export class CameraPinPicture {

  // このインスタンスのメインコンテナ
  private element: any;

  private _visible: boolean;

  private target:  THREE.Object3D;

  private _dispatcher: any;

  private handlers;
  private handlersText;

  private guid: string = '';

  private itemInfo: marietta.webcad.collection.ItemInfoCollection | null;

  private monicaobject: marietta.webcad.item.MonicaObject;

  private linkWrap: HTMLElement; // 画像部分
  private textWrap: HTMLElement; // テキスト部分
  private textElement: HTMLElement; // テキストビュー
  private unSelectedBtn: HTMLElement; // 非選択ボタン

  constructor(id: string, container: HTMLElement, object: THREE.Object3D, dispatcher: any) {
    this._dispatcher = dispatcher;
    this.target = object;
    this.pinPicture(id, container);
  }

  /**
   * 幅取得
   */
  private getWidth(): number {
    return PINPICTURE3D_MAXWIDTH;
  }

  /**
   * 高さ取得
   */
  private getHeight(): number {
    return PINPICTURE3D_MAXHEIGHT;
  }

  /**
   * 吹き出し作成
   */
  public pinPicture(id: string, container: HTMLElement) {
    // イベントが存在したら削除
    if (this.handlersText) this.handlersText.forEach(handler => handler());

    // ピンクリック時に表示される枠の幅・高さの取得
    const width = this.getWidth();
    const height = this.getHeight();

    const camera = ThreeView.get().wcCameras.camera;

    // ポップアップ
    this.element = document.createElement('div');
    this.element.setAttribute('id', id);
    this.element.setAttribute('class', 'pinPictureInput3D');
    this.element.inert = false;
    container.appendChild(this.element);

    // サイズ指定
    this.element.style.width = `${width}px`;
    this.element.style.height = `${height}px`;
    // 位置決め
    const pos = this.positionFromObject(this.target, camera);
    this.element.style.position = 'absolute';
    this.element.style.left = `${pos.x}px`;
    this.element.style.top = `${pos.y}px`;

    // 枠
    const innerElement:HTMLElement = document.createElement('div');
    innerElement.setAttribute('class', 'inner');
    this.element.appendChild(innerElement);

    // 選択解除ボタン
    this.unSelectedBtn = this.unSelectedElement();
    this.unSelectedBtn.style.display = 'block';
    innerElement.appendChild(this.unSelectedBtn);

    // マウスイベント
    this.addEventPointer('pinPicture', this.element);

    this.guid = this.target.userData.modelInfo.uuid;
    this.monicaobject = <marietta.webcad.item.MonicaObject>marietta.webcad.WebCADGlobal.layerGroup.getItemWithGuid(this.guid);
    if (this.monicaobject != null) {
      this.itemInfo = this.monicaobject.itemInfo;
      // URLがあったら、画像部分の作成を行う
      if (this.itemInfo.link && this.itemInfo.link.length > 0) {
          this.linkWrap = this.createLimkElement(width);
          this.linkWrap.style.display = 'block';
          innerElement.appendChild(this.linkWrap);
      }

      // テキスト入力
      const textString = this.itemInfo.text; // テキストサイズを取得
      const textArray = textString.split('\n'); // テキスト項目に改行があれば分割
      this.textWrap = this.createTextWrapElement(textArray);
      this.textWrap.style.display = 'block';
      innerElement.appendChild(this.textWrap);

      // テキストビュー
      this.textElement = this.setTextWrapStyle(textString);
      this.textElement.style.display = 'none';
      innerElement.appendChild(this.textElement);
    }

  }

  /**
   * スクリーン座標を取得する
   */
  private getScreenPosition(camera: marietta.view3d.base.Camera, point: THREE.Vector3): THREE.Vector2 {
      const projection = point.project(camera.me);
      const size = CanvasInfo.get().size;
      const sx = (size.x / 2) * (+projection.x + 1.0);
      const sy = (size.y / 2) * (-projection.y + 1.0);
      return new THREE.Vector2(sx, sy);
  }

  /**
   * 選択解除の×ボタン
   */
  private unSelectedElement() {
    const btn: HTMLElement = document.createElement('a');
    btn.innerHTML = '×';
    btn.setAttribute('class', 'btn-unSelected');
    btn.setAttribute('href', '#');
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      ThreeView.get().unSelectedObject();
    });
    return btn;
  }

  /**
   * 画像部分の作成
   */
  private createLimkElement(width: number): HTMLElement {
    const linkElem: HTMLElement = document.createElement('img');
    linkElem.setAttribute('class', 'pinImg');

    const maxWidth = width - 20; // margin(10*2)分引く
    const viewHeight = 250; // imgの表示領域 190px(linkWrap) - 20px(textWrap margin)
    const maxHeight = viewHeight - 40; // margin(20*2)分引く
    linkElem.style.maxWidth = `${maxWidth}px`;
    linkElem.style.maxHeight = `${maxHeight}px`;

    linkElem.addEventListener('load', (e: Event) => {
      const imgWidth = (<HTMLImageElement>e.target).width;
      const imgHeight = (<HTMLImageElement>e.target).height;
      const ratio = imgHeight / imgWidth;
      let top = 0;
      let left = 0;
      if (ratio <= 1) { // 正方形、もしくは横長
        const h = imgHeight * (maxWidth / imgWidth);
        top = Math.abs(viewHeight - h) / 2;
        left = 10;
      } else { // 縦長
        const w = imgWidth * (maxHeight / imgHeight);
        left = Math.abs(width - w) / 2;
        top = 20;
      }
      linkElem.style.margin = `${top}px ${left}px`;
    });

    linkElem.setAttribute('src', this.itemInfo.link[0].url);

    const atag: HTMLElement = document.createElement('a');
    atag.setAttribute('href', this.itemInfo.link[0].url);
    atag.setAttribute('target', '_blank');
    atag.style.position = 'relative';
    atag.style.display = 'inline-block';
    atag.appendChild(linkElem);

    const linkElemWrap:HTMLElement = document.createElement('div');
    linkElemWrap.setAttribute('class', 'linkWrap');
    linkElemWrap.appendChild(atag);

    return linkElemWrap;
  }

  /**
   * テキスト入力
   */
  private createTextWrapElement(textArray: string[]): HTMLElement {
    const textWrap:HTMLElement = document.createElement('div');
    textWrap.setAttribute('class', 'textWrap');

    let selectText: HTMLElement = document.createElement('a');
    selectText.setAttribute('class', 'selectText');
    selectText.setAttribute('href', '#');
    selectText = this.setTextStyle(selectText);
    selectText.innerHTML = (textArray.length == 1 && textArray[0] === '') ? '文字を入力してください' : textArray.join('<br>');
    selectText.addEventListener('pointerdown', (e) => {
      e.stopPropagation();
      this.setDisplay();
    });
    textWrap.appendChild(selectText);

    return textWrap;
  }

  /**
   * テキスト入力 イベント付与
   */
  private addEventText(elemet: HTMLElement) {

    const focusEvent = (e) => {
      ThreeView.get().isFocusText = true;
      ThreeView.get().controller.pinPictureOver(e);
      document.addEventListener('touchstart', focusOutEvent, {once: true}); // SPのみ1度クリックすると選択状態が取れる
    };
    const focusOutEvent = (e) => {
      ThreeView.get().isFocusText = false;
      ThreeView.get().controller.pinPictureOut(e);
    }
    const elementTouchOver = (e) => {
      e.stopPropagation(); // イベントを伝搬させない
    }
    const self = this;
    const inputEvent = (e) => {
      self.itemInfo.text = (<HTMLTextAreaElement>e.target).value;
      self.monicaobject.reCreateImage();
    }

    const addHandler = (name_: string, element, func)  => {
      element.addEventListener(name_, func);
      return () => element.removeEventListener(name_, func);
  }
    this.handlersText = [
        addHandler('focus', elemet, focusEvent),
        addHandler('blur', elemet, focusOutEvent),
        addHandler('input', elemet, inputEvent),
        addHandler('mouseup', elemet, elementTouchOver),
        addHandler('touchmove', elemet, elementTouchOver)
    ];
}

  /**
   * テキスト入力のスタイル設定
   */
  private setTextWrapStyle(textString: string) {
    const textWrapView = document.createElement('div');
    textWrapView.setAttribute('class', 'textWrapView');

    let btn: HTMLElement = document.createElement('a');
    btn.innerHTML = '←';
    btn.setAttribute('class', 'btn-circle');
    btn.setAttribute('href', '#');
    const self = this;
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.setDisplay();
      const textString = self.itemInfo.text; // テキストサイズを取得
      const textArray = textString.split('\n'); // テキスト項目に改行があれば分割
      self.textWrap.getElementsByClassName('selectText')[0].innerHTML = (textArray.length == 1 && textArray[0] === '') ? '文字を入力してください' : textArray.join('<br>');
    });

    let textAreaElement = document.createElement('textarea');
    textAreaElement.setAttribute('class', 'contentWrap');
    textAreaElement.setAttribute('placeholder', '文字を入力してください');
    textAreaElement.value = textString;
    this.addEventText(textAreaElement);

    textWrapView.appendChild(btn);
    textWrapView.appendChild(this.setTextStyle(textAreaElement));
    return textWrapView;
  }

  /**
   * ディスプレイの切り替え
   */
  private setDisplay() {
    this.linkWrap.style.display = this.linkWrap.style.display == 'none' ? 'block' : 'none';
    this.textWrap.style.display = this.textWrap.style.display == 'none' ? 'block' : 'none';
    this.textElement.style.display = this.textElement.style.display == 'none' ? 'block' : 'none';
    this.unSelectedBtn.style.display = this.unSelectedBtn.style.display == 'none' ? 'block' : 'none';
  }

  /**
   * テキストのスタイル部分
   */
  private setTextStyle(textElement: HTMLElement | HTMLTextAreaElement): HTMLElement | HTMLTextAreaElement {
    textElement.style.fontSize = '14px';
    textElement.style.color = this.itemInfo.text_color;
    textElement.style.fontFamily = marietta.webcad.WebCADGlobal.freeTextFontFamily;

    if (this.itemInfo.is_italic) {
      textElement.style.fontStyle = 'italic';
    }
    if (this.itemInfo.is_bold) {
      textElement.style.fontWeight = 'bold';
    }
    if (this.itemInfo.is_underline) {
      textElement.style.textDecoration = 'underline';
    }
    if (this.itemInfo.is_strike_through) {
      textElement.style.textDecoration = 'line-through';
    }
    textElement.style.textAlign = this.itemInfo.text_alignment;

    // スクロール
    if (this.itemInfo.text_alignment === 'center') {
      const scrollto = (textElement.scrollWidth - textElement.clientWidth) / 2;
      textElement.scrollLeft = scrollto;
    } else if (this.itemInfo.text_alignment === 'right') {
      const scrollto = (textElement.scrollWidth - textElement.clientWidth);
      textElement.scrollLeft = scrollto;
    }

    return textElement;

  }

  /**
   * オブジェクト位置から吹き出しの位置を算出する
   */
  public positionFromObject(object: THREE.Object3D, camera: marietta.view3d.base.Camera): THREE.Vector2 {
    const point = object.getWorldPosition(new THREE.Vector3);
    let pos = this.getScreenPosition(camera, point);
    const bbox = new THREE.Box3();
    bbox.setFromObject(object);
    pos.x = pos.x - PINPICTURE3D_MAXWIDTH / 2;
    const max = this.getScreenPosition(camera, bbox.max);
    pos.y = max.y - PINPICTURE3D_MAXHEIGHT - 25;

    return pos;
  }

  public getTargetObject() {
    return this.target;
  }

  // removed
  public removed() {
    // 子要素を全て削除
    while (this.element.firstChild) this.element.removeChild(this.element.firstChild);
    // 自分を削除
    this.element.parentNode.removeChild(this.element);
  }

  // update
  public update(v2: any) {
    if (this._visible == false) return;
    // 座標をセット
    this.element.style.left = `${v2.x}px`;
    this.element.style.top = `${v2.y}px`;
    // 2D の位置が表示範囲外の時は、表示フラグ（_visible）は保持したまま非表示にする。 y軸はipadの表示を考慮して甘くしてます
    this.element.style.display = (v2.x < 0 || v2.y < -200) ? 'none' : 'block';
  }

  public hide() {
    this.update({ x: -100, y: -100 });
  }

  private mouseOver(msg: string) {
    this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.mouseOver, msg));
  }

  private mouseOut(msg: string) {
    this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.webcad.webcadDefines.WebCadEventNames.mouseOut, msg));
  }

  // イベントの付与
  private addEventPointer(name: string, elemet) {
    const addHandler = (name_: string, element, func)  => {
        element.addEventListener(name_, func);
        return () => element.removeEventListener(name_, func);
    }

    this.handlers = [
        addHandler('pointerover', elemet, e => this.mouseOver(name)),
        addHandler('pointerout', elemet, e => this.mouseOut(name))
    ];
}

}